import { useEffect } from 'react';

// While a full-screen view is open, the page under it doesn't scroll and its
// scrollbar is hidden. Counted, so views opened on top of each other (Plate
// studio → Package → People) only give the scrollbar back when the last closes.
let open = 0;
let saved = '';

export function useLockPageScroll(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const root = document.documentElement;
    if (open === 0) {
      saved = root.style.overflow;
      root.style.overflow = 'hidden';
    }
    open += 1;
    return () => {
      open -= 1;
      if (open === 0) root.style.overflow = saved;
    };
  }, [active]);
}
